import { render } from "./App.vue?vue&type=template&id=a31b056c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a31b056c&lang=css"

import exportComponent from "/Users/savvy/workspace/innotrail/MentoTestUI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__